var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilityWater48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_11104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0032 32.9033C37.9119 34.9919 39.0406 36.583 39.3894 37.6767C39.9126 39.3171 39.4526 40.7279 38.096 41.732C36.7394 42.7361 35.3323 42.7845 33.9103 41.732C32.4884 40.6795 32.1034 39.2868 32.6169 37.6767C32.9593 36.6033 34.088 35.0121 36.0032 32.9033Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3999 14.9025V10.1025H21.5999V14.9025",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3999 14.9025V10.1025H21.5999V14.9025",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4236 6.50293H17.5766C16.485 6.50293 15.6001 7.30882 15.6001 8.30293C15.6001 9.29704 16.485 10.1029 17.5766 10.1029H30.4236C31.5152 10.1029 32.4001 9.29704 32.4001 8.30293C32.4001 7.30882 31.5152 6.50293 30.4236 6.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8055 14.7412H6V22.8075H31.4785V26.9032H40.8V17.5828C40.8 16.0135 39.4636 14.7412 37.815 14.7412H31.8055Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2 26.9033H30.8C30.3582 26.9033 30 27.3331 30 27.8633V29.5433C30 30.0735 30.3582 30.5033 30.8 30.5033H41.2C41.6418 30.5033 42 30.0735 42 29.5433V27.8633C42 27.3331 41.6418 26.9033 41.2 26.9033Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_11104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilityWater48);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityWater48.60733c0f6979a15235b4bb779bab65d2.svg";
export { ForwardRef as ReactComponent };